import React from "react";
import { Anchor, Eye, Globe2 } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export const Missions = () => {
  const { t } = useT();
  const MISSIONS = [
    { icon: Anchor, title: t("missions.pillar1_title"), text: t("missions.pillar1_text") },
    { icon: Eye, title: t("missions.pillar2_title"), text: t("missions.pillar2_text") },
    { icon: Globe2, title: t("missions.pillar3_title"), text: t("missions.pillar3_text") },
  ];
  return (
    <section
      id="missions"
      data-testid="missions-section"
      className="relative"
      style={{ background: "#F5EFE0" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#A88420] mb-3 ornament">
              {t("missions.eyebrow")}
            </div>
            <h2 className="font-serif-bv text-4xl sm:text-5xl lg:text-6xl text-[#1B3022] leading-[1.05]">
              {t("missions.title_1")}
              <br />
              {t("missions.title_2")} <span className="italic text-[#D4AF37]">{t("missions.title_italic")}</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-6">
            <p className="text-base sm:text-lg text-[#1B3022]/75 max-w-xl leading-relaxed">
              {t("missions.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {MISSIONS.map((m, i) => {
            const Icon = m.icon;
            return (
              <div
                key={m.title}
                data-testid={`mission-card-${i}`}
                className="mission-card rounded-sm p-8 lg:p-10 fade-up"
                style={{ animationDelay: `${0.1 * i}s` }}
              >
                <div className="h-14 w-14 rounded-sm border border-[#D4AF37] flex items-center justify-center mb-7">
                  <Icon className="text-[#D4AF37]" size={26} />
                </div>
                <div className="font-serif-bv text-2xl lg:text-3xl text-[#D4AF37] mb-3">
                  {m.title}
                </div>
                <p className="text-sm text-[#F5EFE0]/85 leading-relaxed">{m.text}</p>
                <div className="gold-divider mt-8" />
                <div className="mt-4 text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]/70">
                  ❖ {t("missions.pillar")} {String(i + 1).padStart(2, "0")}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Missions;
